import { render, staticRenderFns } from "./interim-table.vue?vue&type=template&id=71351ad3&scoped=true"
import script from "./interim-table.vue?vue&type=script&lang=js"
export * from "./interim-table.vue?vue&type=script&lang=js"
import style0 from "./interim-table.vue?vue&type=style&index=0&id=71351ad3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71351ad3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71351ad3')) {
      api.createRecord('71351ad3', component.options)
    } else {
      api.reload('71351ad3', component.options)
    }
    module.hot.accept("./interim-table.vue?vue&type=template&id=71351ad3&scoped=true", function () {
      api.rerender('71351ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/interim-table.vue"
export default component.exports